module.exports = __webpack_public_path__ + "static/wildfire-d0d76d1fb0f4ef44350b2c39b3f9ecda.jpg";